/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import AppRouterDefinition from "../../../AppRouterDefinition";
const PortalView = React.lazy(() => import(/* webpackChunkName: "Buchungsportal" */"../Views/PortalView"));

export const BUCHUNGSPORTAL_PATH = "/buchungsportal";
export const BUCHUNGSPORTAL_SUCHE_PATH_PART = "/suche/:suchname";

export const buchungsportalRouterDefinitions: Array<AppRouterDefinition> = [
    {
        path: BUCHUNGSPORTAL_PATH,
        render: (props) => <PortalView />,
        createBreadcrumbs: () => [],
        hideHeader: true,
        unauthorized: true
    }
];
